module.exports = __webpack_public_path__ + "img/categoria-5.f17a3e92.png";